module.exports = __webpack_public_path__ + "img/_argentina.9dc517ac.png";